import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("boba_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const outlet = localStorage.getItem("boba_outlet");
  if (outlet) {
    config.headers["X-Outlet-Id"] = outlet;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname !== "/login") {
      localStorage.removeItem("boba_token");
      localStorage.removeItem("boba_staff");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
